export function storeGallery() {
    document.querySelectorAll('[data-store-gallery]').forEach((gallery) => {
        const main = gallery.querySelector('[data-store-gallery-main]');
        const thumbs = gallery.querySelector('[data-store-gallery-thumbs]');

        if (!main || typeof window.Flickity === 'undefined') return;

        const mainCarousel = new window.Flickity(main, {
            cellAlign: 'left',
            contain: true,
            draggable: main.children.length > 1,
            prevNextButtons: false,
            pageDots: false,
            imagesLoaded: true,
            adaptiveHeight: false,
            wrapAround: main.children.length > 1,
        });

        if (!thumbs) return;

        const thumbCarousel = new window.Flickity(thumbs, {
            asNavFor: main,
            cellAlign: 'left',
            contain: true,
            prevNextButtons: false,
            pageDots: false,
            imagesLoaded: true,
        });

        thumbs.querySelectorAll('.store-gallery__thumb').forEach((thumb, index) => {
            thumb.addEventListener('click', () => mainCarousel.select(index));
        });

        mainCarousel.on('change', (index) => {
            thumbCarousel.selectCell(index);
        });
    });
}
